<div class="layout-wrapper" (click)="onLayoutClick()"
     [ngClass]="{'layout-menu-slim': slimMenu,
                'layout-menu-overlay': overlayMenu,
                'layout-menu-static': staticMenu,
                'layout-menu-static-inactive': staticMenuInactive,
                'layout-menu-overlay-active': overlayMenuActive,
                'layout-menu-active': mobileMenuActive}">

    <topbar></topbar>

    <div class="layout-main">
        <!-- <menu></menu> -->

        <div class="layout-content bg-image-watermark" style="width: 100%; height: 40%;">
            <router-outlet></router-outlet>
        </div>

        <footer></footer>
    </div>


</div>

<p-confirmDialog key="unsavedChangesDialog" header="Confirmación"></p-confirmDialog>
